export const NOTIFICATIONS_PANEL_WIDTH = 400;

export const BOTTOM_RIGHT_TOASTER_ID = "bottom-right";
